<template>
  <a
    :href="deepLink"
    v-if="isAppInstalled || !isCheckSupported"
    :class="$style.button"
  >
    <NewButton>{{ $t(text || 'modals.startLesson.open') }}</NewButton>
  </a>
</template>

<script setup>
import NewButton from '@/shared/components/UI/Button/NewButton.vue';

const { isCheckSupported, isAppInstalled } = defineProps({
  deepLink: {
    type: String,
    default: '#',
  },
  isCheckSupported: {
    type: Boolean,
    default: false,
  },
  isAppInstalled: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" module>

.button {
  display: block;
  margin-top: 24px;
}
</style>